import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as UpcomingIcon } from '../../../assets/icons/upcoming-icon.svg';
import './UpcomingSection.scss';

function UpcomingSection() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  return (
    <section className={`upcoming ${isEn ? 'upcoming--en' : ''}`}>
      <div className="upcoming__icon-wrapper">
        <div className="upcoming__icon-glow" />
        <div className="upcoming__icon-ring">
          <UpcomingIcon className="upcoming__icon" />
        </div>
      </div>

      <h2 className="upcoming__title">{t('home.upcoming.title')}</h2>
      <p className="upcoming__desc">{t('home.upcoming.desc')}</p>

      <div className="upcoming__dots">
        <span className="upcoming__dot upcoming__dot--sage" />
        <span className="upcoming__dot upcoming__dot--amber" />
        <span className="upcoming__dot upcoming__dot--rose" />
        <span className="upcoming__dot upcoming__dot--steel" />
      </div>
    </section>
  );
}

export default UpcomingSection;
